import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "countrySelector", "intervalToggle"]
  static values = {
    selectedCountry: String,
    selectedInterval: { type: String, default: "month" }
  }

  connect() {
    this.selectedCountryValue = this.countryTargetValue || this.selectedCountryValue
    this.updatePlans()
  }

  changeCountry(event) {
    this.selectedCountryValue = event.target.value
    this.updatePlans()
  }

  changeInterval(event) {
    const interval = event.currentTarget.dataset.interval
    this.selectedIntervalValue = interval
    
    // Update toggle button styles
    this.intervalToggleTargets.forEach(toggle => {
      if (toggle.dataset.interval === interval) {
        toggle.classList.add("bg-indigo-600", "text-white")
        toggle.classList.remove("text-slate-700", "dark:text-slate-300")
      } else {
        toggle.classList.remove("bg-indigo-600", "text-white")
        toggle.classList.add("text-slate-700", "dark:text-slate-300")
      }
    })
    
    this.updatePlans()
  }

  updatePlans() {
    this.cardTargets.forEach(card => {
      const matchesCountry = card.dataset.country === this.selectedCountryValue
      const matchesInterval = card.dataset.interval === this.selectedIntervalValue
      
      if (matchesCountry && matchesInterval) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })
  }

  get countryTargetValue() {
    return this.hasCountrySelectorTarget ? this.countrySelectorTarget.value : "US"
  }
}
